import React, { useState } from "react";
import { motion } from "framer-motion";
import { Wallet, Percent, Truck, Droplets, Crown, ArrowRight } from "lucide-react";
import { startCheckout } from "../lib/checkout";
import { TIERS } from "../data/tiers";
import { TAP, fadeUp } from "../lib/motion";

const MATH = [
  { label: "PAY $299", sub: "PER MONTH" },
  { label: "GET $400", sub: "STORE CREDIT" },
  { label: "+ 40% OFF", sub: "ALL ORDERS" },
  { label: "≈ $700", sub: "MONTHLY VALUE" },
];

const PERKS = [
  { icon: Wallet, label: "$100+ FREE CREDIT EVERY MONTH" },
  { icon: Percent, label: "40% MEMBER PRICING" },
  { icon: Truck, label: "FREE SHIPPING" },
  { icon: Droplets, label: "FREE BAC WATER" },
  { icon: Crown, label: "VIP ELITE ACCESS" },
];

const goldBorder = { border: "1px solid rgba(212,175,55,0.3)" };
const goldRadial = { background: "radial-gradient(50% 40% at 50% 0%, rgba(212,175,55,0.07), transparent 70%)" };

const MathStrip = () => (
  <div className="mt-14 flex flex-col md:flex-row items-stretch md:items-center justify-center gap-4 md:gap-2 max-w-4xl mx-auto">
    {MATH.map((m, i) => (
      <React.Fragment key={m.label}>
        <motion.div
          className={`flex-1 flex flex-col items-center text-center gap-1 py-6 px-4 glass ${i === MATH.length - 1 ? "glow-gold" : ""}`}
          style={goldBorder}
          {...fadeUp(i * 0.08)}
          data-testid={`elite-math-${i}`}
        >
          <span className={`font-display text-2xl sm:text-3xl font-700 ${i === MATH.length - 1 ? "text-gold" : "text-white"}`}>{m.label}</span>
          <span className="eyebrow text-[0.55rem] text-dim">{m.sub}</span>
        </motion.div>
        {i < MATH.length - 1 && (
          <ArrowRight size={18} className="text-gold mx-auto md:mx-0 rotate-90 md:rotate-0 shrink-0" />
        )}
      </React.Fragment>
    ))}
  </div>
);

const PerksRow = () => (
  <motion.div className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-4" {...fadeUp(0.15)}>
    {PERKS.map((p) => (
      <div key={p.label} className="flex items-center gap-2.5">
        <p.icon size={18} className="text-gold" strokeWidth={1.5} />
        <span className="font-display text-xs sm:text-sm font-600 tracking-wide text-white/90">{p.label}</span>
      </div>
    ))}
  </motion.div>
);

export const WhyElite = () => {
  const [loading, setLoading] = useState(false);
  return (
    <section className="relative py-20 sm:py-28 bg-[#0A0D10] border-y border-[var(--border)] overflow-hidden" data-testid="why-elite">
      <div className="absolute inset-0 pointer-events-none" style={goldRadial} />
      <div className="relative max-w-6xl mx-auto px-5">
        <motion.p className="eyebrow text-gold text-center mb-6" {...fadeUp()}>
          For Serious Biohackers
        </motion.p>

        <motion.h2
          className="text-center font-display text-3xl sm:text-5xl font-700 tracking-tight text-white leading-[1.05]"
          {...fadeUp(0.05)}
        >
          RUNNING PROTOCOL ALL YEAR?
          <br />
          <span className="bg-gradient-to-r from-[#D4AF37] to-[#F1DE9C] bg-clip-text text-transparent">
            ELITE IS MAXIMUM SAVINGS.
          </span>
        </motion.h2>

        <motion.p className="mt-6 text-center text-dim text-base sm:text-lg max-w-2xl mx-auto" {...fadeUp(0.1)}>
          Pay $299 and get $400 in store credit — that's $100+ in free credit every
          month — plus 40% off everything you order and every premium benefit we offer.
        </motion.p>

        <MathStrip />
        <PerksRow />

        <div className="mt-12 flex flex-col items-center gap-3">
          <motion.button
            whileTap={TAP}
            onClick={() => startCheckout(TIERS.elite.lookupKey, setLoading)}
            disabled={loading}
            className="cta-gold px-10 py-4 text-sm disabled:opacity-60"
            data-testid="why-elite-cta"
          >
            {loading ? "REDIRECTING…" : "JOIN ELITE — $299/MONTH"}
          </motion.button>
          <p className="text-xs text-dim">≈ $700 in monthly value • Maximum savings • All premium benefits</p>
        </div>
      </div>
    </section>
  );
};
